import { gql } from 'graphql-request'

export const FIND_BOOK_COLLECTION = gql`
  query FindBookCollection($privacyType: CollectionPrivacyType) {
    findBookCollection(privacyType: $privacyType) {
      id
      collectionName
      privacyType
      description
      books {
        id
        writer
        title
        coverImgPath
        penName {
          firstPenName
        }
      }
    }
  }
`
